/* global axios */
import ApiClient from './ApiClient';

class TalkviaFunnelsAPI extends ApiClient {
  constructor() {
    super('talkvia_funnels', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  create(data) {
    return axios.post(this.url, { talkvia_funnel: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { talkvia_funnel: data });
  }
}

export default new TalkviaFunnelsAPI();
